"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingDateService = void 0;
var KAM_STANDARD_CARRIER_CODE = 'kam-standard';
var KAM_EXPRESS_CARRIER_CODE = 'kam-express';
var ShippingDateService = /** @class */ (function () {
    function ShippingDateService(shippingServiceUrl, htmlElement, locale, hasStandardShipping, hasExpressShipping, appendSuperscript, superscript) {
        if (appendSuperscript === void 0) { appendSuperscript = false; }
        if (superscript === void 0) { superscript = 2; }
        this.shippingServiceUrl = shippingServiceUrl;
        this.htmlElement = htmlElement;
        this.locale = locale;
        this.hasStandardShipping = hasStandardShipping;
        this.hasExpressShipping = hasExpressShipping;
        this.appendSuperscript = appendSuperscript;
        this.superscript = superscript;
    }
    ShippingDateService.prototype.calcShippingDay = function (productOption) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.updateHtmlElement;
                        return [4 /*yield*/, this.requestCustomerInformation([this.productOptionToProductOptionPayload(productOption)])];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        });
    };
    ShippingDateService.prototype.calcShippingDayForAllProducts = function (productOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var productOptionsPayload, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        productOptionsPayload = productOptions.map(this.productOptionToProductOptionPayload);
                        _a = this.updateHtmlElement;
                        return [4 /*yield*/, this.requestCustomerInformation(productOptionsPayload)];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        });
    };
    ShippingDateService.prototype.requestCustomerInformation = function (productOptionsPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var searchParams, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchParams = new URLSearchParams({
                            locale: this.locale,
                        });
                        if (this.hasStandardShipping) {
                            searchParams.append('carrier', KAM_STANDARD_CARRIER_CODE);
                        }
                        if (this.hasExpressShipping) {
                            searchParams.append('expressCarrier', KAM_EXPRESS_CARRIER_CODE);
                        }
                        productOptionsPayload.forEach(function (productOption, index) {
                            for (var _i = 0, _a = Object.entries(productOption); _i < _a.length; _i++) {
                                var _b = _a[_i], key = _b[0], value = _b[1];
                                searchParams.append("products[".concat(index, "][").concat(key, "]"), String(value));
                            }
                        });
                        return [4 /*yield*/, fetch("".concat(this.shippingServiceUrl, "?").concat(searchParams), {
                                method: 'GET',
                                mode: 'cors',
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json.customerInformation];
                }
            });
        });
    };
    ShippingDateService.prototype.updateHtmlElement = function (info) {
        this.htmlElement.innerHTML = "".concat(info, " ").concat(this.appendSuperscript ? "<sup>".concat(this.superscript, "</sup>") : '');
    };
    ShippingDateService.prototype.productOptionToProductOptionPayload = function (productOption) {
        var _a, _b, _c, _d, _e, _f;
        return {
            format: (_a = productOption.format) !== null && _a !== void 0 ? _a : '',
            productGroup: productOption.category,
            refinement: (_b = productOption.refinement) !== null && _b !== void 0 ? _b : '',
            diecut: (_c = productOption.diecut) !== null && _c !== void 0 ? _c : '',
            tag: (_d = productOption.tag) !== null && _d !== void 0 ? _d : '',
            paper: (_e = productOption.paper) !== null && _e !== void 0 ? _e : '',
            frame: (_f = productOption.frame) !== null && _f !== void 0 ? _f : '',
            quantity: productOption.quantity,
        };
    };
    return ShippingDateService;
}());
exports.ShippingDateService = ShippingDateService;
